import { createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import { checkToken } from '../misc/utils'

// Define a type for the slice state
interface UserState {
    status: string,
    error: string,
}

// Define the initial state usiEng that type
const initialState: UserState = {
    status: '',
    error: ''
}


export const updateSource =  createAsyncThunk('updateSource', async ({source}: {source: string}, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/user/source`, {
		method: 'PUT',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({source: source})
	})

	return response.json()
})


export const updateReview =  createAsyncThunk('updateReview', async ({review}: {review: boolean}, store) => {
	const token = await checkToken(store)

	const response = await fetch(`${process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_LOCAL_API_URL : process.env.REACT_APP_API_URL}/user/review`, {
		method: 'PUT',
		credentials: 'include',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({review: review})
	})

	return response.json()
})


export const userSlice = createSlice(
	{
		name: 'user',
		initialState,
		reducers: {},
		extraReducers(builder) {
			builder
			// getToken
			.addCase(updateSource.fulfilled, (state, action) => {
				state.status = 'succeeded'
				console.log("updateSource : fulfilled")
			})
            .addCase(updateSource.rejected, (state, action) => {
				console.log("updateSource : rejected")
				state.status = 'failed'

                const payload = action.payload as {error: string}
                state.error = payload?.error
                
			})
		}
	}
)

export default userSlice.reducer
